import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps } from 'react-router';
import { AppActions } from 'app/actions';
import { omit } from 'app/utils';
import { RootState } from 'app/reducers';
import './style.css';
import { Button, Intent, Card, Elevation, Spinner, Callout, Menu, Popover, Position, H4 } from "@blueprintjs/core";
import { UserState } from 'app/reducers';
import { executeQueryPost, executeInlineAuthGet, executeQueryGet } from 'app/utils/api';
import { buildInputTranslated, translateKey } from 'app/utils/forms';
import { StandardInput } from 'app/components/StandardInput';
import { ForgotPassword } from 'app/components/ForgotPassword';
import { LargeButton } from 'app/components/LargeButton';
import { ResetPassword } from 'app/components/ResetPassword';
// Using URLSearchParams instead of Node.js querystring for browser compatibility
import { renderNormalButtonTranslated } from '../../utils/forms';

const VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER = 'vleader-session-at-id';
const VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER  = VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + '-type';
const VLEADER_USERNAME_KEY = 'vleader-remembered-email';

interface Props extends RouteComponentProps<void> {
	user: UserState;
	actions: AppActions;
}

interface State {
	inputUsername: string;
	inputPassword: string;
	errorMessage: string;
	isLoading: boolean;
	isRegisterLoading: boolean;
	isSessionLoading: boolean;
	userRecoveryCode: string;
	loginPhase: string;
	loadingPaypal: boolean;
	registerGender: string;
	unityMode: boolean;
	showPatcher: boolean;
}

@connect(
	(state: RootState, ownProps: any): Partial<Props> => {
		return { user: state.user };
	},
	(dispatch: Dispatch): Pick<Props, 'actions'> => ({
		actions: bindActionCreators(omit(AppActions, 'Type'), dispatch)
	})
)
export class Login extends React.Component<Props> {
	static defaultProps: Partial<Props> = {
		
	};

	state:State = {
		inputUsername: '',
		inputPassword: '',
		errorMessage: '',
		isRegisterLoading: false,
		isLoading: false,
		loadingPaypal: false,
		loginPhase: 'login',
		isSessionLoading: false,
		userRecoveryCode: "",
		registerGender: "female",
		unityMode: false,
		showPatcher: false
	}

	constructor(props: Props, context?: any) {
		super(props, context);

		const existingSessionToken = window.localStorage.getItem(VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER);

		if (existingSessionToken !== undefined && existingSessionToken !== '' && existingSessionToken !== null) {
			this.state.isSessionLoading = true;
		}
	}

	// setupWS = () => {
	// 	const ws = new WebSocket("wss://u4i9iuhy77.execute-api.us-east-1.amazonaws.com/prod");

	// 	const apiCall = {
	// 		event: "bts:subscribe",
	// 		data: { channel: "order_book_btcusd" },
	// 	};

	// 	ws.onopen = (event) => {
	// 		ws.send(JSON.stringify(apiCall));
	// 	};

	// 	ws.onmessage = function (event) {
	// 		console.log(event);
	// 	};
	// }

	handleAuthentication = (token: string, userID: string) => {
		window.localStorage.setItem(
			VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER,
			token
		);

		window.localStorage.setItem(
			VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + "--id",
			userID
		);

		executeInlineAuthGet("users/" + userID.toString(), {}, token, (userDataResponse) => {

			let userResponse = userDataResponse.body;

			userResponse["authenticationToken"] = token; // Store the token in our state

			this.props.actions.userLogin({
				payload: userResponse
			});
		});
	}

	componentWillMount() {
		// Check for a given user recovery key
		const history = this.props.history;
		const location = history.location;
		const searchAsQuery = new URLSearchParams(location.search);

		// Force unity mode if domain is streaming.vleader.net or streamingnextgen.vleader.net or if unity query param is present
		const isStreamingDomain = window.location.hostname === 'streaming.vleader.net' || window.location.hostname === 'streamingnextgen.vleader.net';
		if (searchAsQuery.get("unity") !== null || isStreamingDomain) {
			this.setState({
				unityMode: true
			});
		}

		const loadingValue   = searchAsQuery.get('loading');
		const anyLoading     = loadingValue === 'true';

		if (anyLoading) {
			this.setState({
				showPatcher: true
			});
		}
	}

	// debugInsertUser() {
	// 	const tokenResponse = {
	// 		body: {
	// 			id: '388',
	// 			key: 'UisksFveOk8bEPmXfQjhhnZsEKRsXap6frR92BJAYjbA9HHugj'
	// 		}
	// 	};

	// 	executeInlineAuthGet("users/" + tokenResponse.body.id.toString(), {}, tokenResponse.body.key, (userDataResponse) => {

	// 		let userResponse = userDataResponse.body;

	// 		userResponse["authenticationToken"] = tokenResponse.body.key; // Store the token in our state

	// 		try {
	// 			//@ts-ignore
	// 			window.unity_getGender(userResponse['gender']);
	// 		}catch(e){}

	// 		ReactGA.set({ userId: tokenResponse.body.id.toString() });

	// 		this.props.actions.userLogin({
	// 			payload: userResponse
	// 		});

	// 		this.props.history.push("/kry");
	// 	});
	// }

	// Check the local session storage for an API key
	componentDidMount() {
		// Check for a given user recovery key
		const history = this.props.history;
		const location = history.location;
		const searchAsQuery = new URLSearchParams(location.search);

		const loadingValue   = searchAsQuery.get('loading');
		const anyLoading     = loadingValue === 'true';

		if (anyLoading) {
			this.setState({
				showPatcher: true
			});
			return;
		}

		// Check for an existing login key
		const existingUsername = localStorage.getItem(VLEADER_USERNAME_KEY);

		if (existingUsername !== undefined && existingUsername !== '' && existingUsername !== null) {
			this.setState({
				inputUsername: existingUsername
			})
		}

		if (searchAsQuery.get("code") !== null) {
			this.setState({
				userRecoveryCode: searchAsQuery.get("code")
			});
		}
		if (searchAsQuery.get("paypal") !== null) {
			// Let's try and process the paypal transaction
			this.setState({
				loadingPaypal: true
			});

			// Now handle trying to process it
			const SUCCESS_HREF = "transactions/paypal/" + searchAsQuery.get("paypal") + "/success?paymentId=" + searchAsQuery.get("paymentId") + "&token=" + searchAsQuery.get("token") + "&PayerID=" + searchAsQuery.get("PayerID");

			executeQueryGet(SUCCESS_HREF, undefined, (response) => {
				this.props.history.push("/");
			});
		}
		if (searchAsQuery.get("code") === null && searchAsQuery.get("paypal") === null) {
			const existingSessionToken = window.localStorage.getItem(VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER);
			const existingSessionID    = window.localStorage.getItem(VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + "--id");
			const existingType         = window.localStorage.getItem(VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER);

			if (existingSessionToken !== undefined && existingSessionToken !== '' && existingSessionToken !== null) {
				this.setState({
					isSessionLoading: true
				});

				// Check if we should use unity mode (either stored type or streaming domain)
				const isStreamingDomain = window.location.hostname === 'streaming.vleader.net' || window.location.hostname === 'streamingnextgen.vleader.net';
				if (existingType === 'unity' || isStreamingDomain) {
					// Send this out to our "potentialy" unity listener
					//@ts-ignore
					if (window.unity_gotLogin) {
						//@ts-ignore
						window.unity_gotLogin(tokenResponse.body.key + ";" + tokenResponse.body.id);
					}

					executeInlineAuthGet("users/" + existingSessionID, {}, existingSessionToken, (userDataResponse) => {

						let userResponse = userDataResponse.body;
			
						userResponse["authenticationToken"] = existingSessionToken; // Store the token in our state

						try {
							//@ts-ignore
							window.unity_getGender(userResponse['gender']);
						}catch(e){}

						//ReactGA.set({ userId: existingSessionID });
			
						this.props.actions.userLogin({
							payload: userResponse
						});
			
						this.props.history.push("/kry");
					});
				}
				else {
					this.handleAuthentication(
						existingSessionToken,
						existingSessionID!
					);
				}
			}
		}

		//this.debugInsertUser();
	}

	componentDidUpdate() {
		const searchAsQuery = new URLSearchParams(location.search);
		if (this.props.user.authenticated && searchAsQuery.get("paypal") === null) {
			// If the page udates and we've now become authenticated then
			// forward us home
			this.props.history.push("/");
		}
	}

	handleLoginPress = () => {
		const {
			history
		} = this.props;

		this.setState({
			isLoading: true
		});

		executeQueryPost("users/token", {
			email: this.state.inputUsername.trim(),
			password: this.state.inputPassword
		}, (tokenResponse) => {
			const wasSuccessful = tokenResponse.body.success === "true" || tokenResponse.body.success === true;

			const location = history.location;
			const searchAsQuery = new URLSearchParams(location.search);

			// Check if we should use unity mode (either query param or streaming domain)
			const isStreamingDomain = window.location.hostname === 'streaming.vleader.net' || window.location.hostname === 'streamingnextgen.vleader.net';
			if (searchAsQuery.get("unity") !== null || isStreamingDomain) {
				if (wasSuccessful === true) {
					window.localStorage.setItem(
						VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER,
						tokenResponse.body.key
					);
			
					window.localStorage.setItem(
						VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + "--id",
						tokenResponse.body.id
					);

					window.localStorage.setItem(
						VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER,
						'unity'
					);

					// When they login correctly in the "unity" mode
					// We want to keep there email
					localStorage.setItem(VLEADER_USERNAME_KEY, this.state.inputUsername.trim());

					// Send this out to our "potentialy" unity listener
					//@ts-ignore
					if (window.unity_gotLogin) {
						//@ts-ignore
						window.unity_gotLogin(tokenResponse.body.key + ";" + tokenResponse.body.id);
					}

					executeInlineAuthGet("users/" + tokenResponse.body.id.toString(), {}, tokenResponse.body.key, (userDataResponse) => {

						let userResponse = userDataResponse.body;
			
						userResponse["authenticationToken"] = tokenResponse.body.key; // Store the token in our state

						try {
							//@ts-ignore
							window.unity_getGender(userResponse['gender']);
						}catch(e){}

						//ReactGA.set({ userId: tokenResponse.body.id.toString() });
			
						this.props.actions.userLogin({
							payload: userResponse
						});
			
						this.props.history.push("/kry");
					});
				}
				else {
					this.setState({
						errorMessage: 'Error Logging In',
						isLoading: false,
						isRegisterLoading: false
					});
				}
			}
			else {
				if (wasSuccessful === true) {
					this.handleAuthentication(tokenResponse.body.key, tokenResponse.body.id);
				}
				else {
					this.setState({
						errorMessage: 'Error Logging In',
						isLoading: false,
						isRegisterLoading: false
					});
				}
			}
		});
	}

	handleUsernameChange = (e:any) => {
		if (e && e.target) {
			const newValue = e.target.value;

			this.setState({
				inputUsername: newValue
			});
		}
	}

	handlePasswordChange = (e:any) => {
		if (e && e.target) {
			const newValue = e.target.value;

			this.setState({
				inputPassword: newValue
			});
		}
	}

	handlePasswordKeyPress = (e:any) => {
		if (e.key === 'Enter') {
			this.handleLoginPress();
		}
	}

	renderNormalButton = (rightIcon: any, onClick: any, intent: any, text: string) => {
		return <Button style={{width: '50%', marginTop: '20px'}} rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={text} />
	}

	renderLargeButton = (rightIcon: any, onClick: any, intent: any, text: string) => {
		return <LargeButton rightIcon={rightIcon} onClick={onClick} intent={intent} text={text} />
	}

	renderEmailInput() {
		return <StandardInput 
			autoFocus={true}
			onChange={this.handleUsernameChange}
			type={"email"}
			label={translateKey("login.email")} />
	}

	renderPasswordInput() {
		return <StandardInput 
			onChange={this.handlePasswordChange}
			onKeyPress={this.handlePasswordKeyPress}
			type={"password"}
			label={translateKey("login.password")} />
	}

	renderLoginButton = () => {
		const {
			isLoading
		} = this.state;

		if (isLoading) {
			return <Spinner />
		}

		return this.renderLargeButton("log-in", this.handleLoginPress, Intent.SUCCESS, translateKey("login.login"));
	}

	renderErrorMessage = () => {
		const {
			errorMessage
		} = this.state;

		if (errorMessage === undefined || errorMessage === '') return <span></span>

		return <span className={"errorBubble"}>{errorMessage}</span>
	}

	renderLoginHeader = () => {
		return <img className={"login-header-image"} src="assets/img/logo.png" onClick={() => {
			this.setState({
				loginPhase: "login"
			});
		}} />
	}

	renderSoftwareVersion = () => {
		return <span style={{display: 'block', width: '100%', textAlign: 'center', marginTop: '15px'}}>
			{translateKey("login.version") + ": " + window["CURRENT_SOFTWARE_VERSION"]}
		</span>
	}

	renderUserInfoCard = () => {
        const menu = <Menu>
            <Menu.Item icon="cross" onClick={() => {
				//@ts-ignore
				if (window.unity_onExit) {
					//@ts-ignore
					window.unity_onExit();
				}
            }} text={"Exit"} />
        </Menu>

        return <span className="kryMainMenu" style={{ display: 'block' }}>
            <Popover content={menu} position={Position.LEFT_BOTTOM}>
                <Button style={{ float: 'right' }} large icon="menu" />
            </Popover>
            <div className="clearfix" />
        </span>
    }

	renderLoginPhase() {
		const {
			unityMode
		} = this.state;

		return <span>
			{unityMode ? this.renderUserInfoCard() : undefined}
			{this.renderErrorMessage()}
			{this.renderEmailInput()}
			{this.renderPasswordInput()}
			{this.renderLoginButton()}
			{unityMode ? undefined : renderNormalButtonTranslated("add", () => {this.setState({loginPhase: "register"})}, Intent.NONE, "login.createAccount")}
			<span style={{display: 'block', width: '100%', float: 'right', height: '0px'}} />
			{unityMode ? undefined : renderNormalButtonTranslated("key", () => {this.setState({loginPhase: "forgot-password"})}, Intent.NONE, "login.forgotPassword")}
		</span>
	}

	renderRegisterPhase() {
		const {
			isRegisterLoading
		} = this.state;

		if (isRegisterLoading) {
			return <Spinner />
		}

		const registerEmailRef = React.createRef<HTMLInputElement>();
		const registerPasswordRef = React.createRef<HTMLInputElement>();
		const registerPasswordReRef = React.createRef<HTMLInputElement>();
		const registerFirstRef = React.createRef<HTMLInputElement>();
		const registerLastRef = React.createRef<HTMLInputElement>();

		return <span>
			<Callout style={{marginBottom: '20px'}} icon="info-sign" intent={Intent.PRIMARY} title={undefined}>
				Please fill out your information below so you can easily find your scores and certificates throughout the duration of your class.
			</Callout>
			{this.renderErrorMessage()}
			{buildInputTranslated("", "", "login.email", "register_email", "email", registerEmailRef)}
			{buildInputTranslated("", "", "login.password", "register_password1", "password", registerPasswordRef)}
			{buildInputTranslated("", "", "login.verifyPassword", "register_password2", "password", registerPasswordReRef)}
			{buildInputTranslated("", "person", "login.firstName", "register_first", "text", registerFirstRef)}
			{buildInputTranslated("", "person", "login.lastName", "register_last", "text", registerLastRef)}
			
			<StandardInput
                    label={translateKey("login.voicePref")}
                    type="dropdown"
                    value={"female"}
                    options={[{value: 'male', label: translateKey('login.male')},{value: 'female', label: translateKey('login.female')}]}
                    onChange={(target) => {
                        this.setState({ registerGender: target.target.value })
                    }}
                />

			{this.renderLargeButton("log-in", () => {
				this.setState({
					isRegisterLoading: true
				});

				const _email    = registerEmailRef.current!.value.trim();
				const _password = registerPasswordReRef.current!.value;

				if (_email.includes("@") && _email.includes(".")) {
					// Handle the user registration
					executeQueryPost("users", {
						email: _email,
						password: _password,
						first: registerFirstRef.current!.value,
						last: registerLastRef.current!.value,
						gender: this.state.registerGender
					}, (authResponse) => {
						executeQueryPost("users/token", {
							email: _email,
							password: _password
						}, (tokenResponse) => {

							const wasSuccessful = tokenResponse.body.success === "true" || tokenResponse.body.success === true;

							if (wasSuccessful === true) {
								const authenticationKey = tokenResponse.body.key;
								const userID = tokenResponse.body.id;

								this.handleAuthentication(authenticationKey, userID);
							}
							else {
								this.setState({
									errorMessage: translateKey('login.loginError'),
									isLoading: false,
									isRegisterLoading: false
								});
							}
						});
					});
				}
				else {
					this.setState({
						errorMessage: translateKey('login.validEmail'),
						isLoading: false,
						isRegisterLoading: false
					});
				}

			}, Intent.SUCCESS, translateKey('login.createAccount'))}
		</span>
	}

	renderCurrentPhase() {
		const {
			loginPhase,
			userRecoveryCode
		} = this.state;

		// If we have recieved a recovery code, then we should handle resetting the user's password
		if (userRecoveryCode !== '') {
			return <ResetPassword code={userRecoveryCode} recoveryDone={() => {

			}} />
		}

		if (loginPhase === 'login') {
			return this.renderLoginPhase();
		}

		if (loginPhase === 'register') {
			return this.renderRegisterPhase();
		}

		if (loginPhase === 'forgot-password') {
			return <ForgotPassword />
		}

		return <span></span>
	}

	render() {
		const {
			isSessionLoading,
			showPatcher
		} = this.state;

		if (showPatcher) {
			return (
				<div>
					<Card elevation={Elevation.TWO} className={"loginCard"}>
						<H4>Updates are downloading...</H4>
						<p>Please wait for a new version of vLeader to install.  When it is complete you will be presented with a popup to install and restart the application.</p>
						<p>This could take up to 10 minutes.</p>
						<Spinner />
						<div className="clearfix" />
					</Card>
					{this.renderSoftwareVersion()}
				</div>
			);
		}
		
		let normalPageInnards = isSessionLoading ? <Spinner /> : this.renderCurrentPhase();

		return (
			<div>
				<Card elevation={Elevation.TWO} className={"loginCard"}>
					{this.renderLoginHeader()}
					{normalPageInnards}
					<div className="clearfix" />
				</Card>
				{this.renderSoftwareVersion()}
			</div>
		);
	}
}
